import { InjectionToken } from "@angular/core";

export const PB_CLIENT_THEME_KEY_TOKEN = new InjectionToken<string>(
	"Client theme key",
);
